import gql from "graphql-tag";

export interface Topic {
  id: string;
  name: string;
  slug: string[];
  type: "Vendor" | "Sector";
}

export const TopicInfo = gql`
  fragment TopicInfo on Topic {
    id
    name
    slug
    type
  }
`;
